import React, {useContext, useMemo} from "react";
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import './ProjectDocuments.scoped.scss';
import DetailedProjectNavigation from "../DetailedProjectNavigation";
import {DocumentScopeType, Role} from "../../../../api-client";
import {useMountAnimation, useWindowWidth} from "../hooks";
import {cn, resultIf} from "../../../../utils";
import ProjectDropdown from "../ProjectDropdown";
import {
  SecondaryProjectContext
} from "../../../../views/dashboard/lender/investment/purchase/SecondaryProjectContext/SecondaryProjectContext";
import SecondaryProjectNavigation
  from "../../../../views/dashboard/lender/investment/purchase/SecondaryProjectNavigation";
import {DocumentCard} from "../../../common";
import {useProfileData} from "../../../../hooks";

const ProjectDocuments = () => {
  const project = useContext(DetailedProjectContext).project;
  const mounted = useMountAnimation();
  const isMobile = useWindowWidth();
  const {role} = useProfileData();
  const offer = !!useContext(SecondaryProjectContext);
  const navigation = useMemo(() => {
    if (offer) {
      return <SecondaryProjectNavigation />;
    }
    else {
      return <DetailedProjectNavigation />;
    }
  }, [offer]);

  const renderDocuments = () => {
    if (!project.documents || project.documents.length === 0) {
      return <div className="project-documents__placeholder">Документы не прилагаются</div>;
    }
    return (
      <ul className="project-documents__list">
        {project.documents
          ?.filter((document) => {
            if (role === Role.LENDER)
              return document.scope === DocumentScopeType.LENDER || document.scope === DocumentScopeType.COMMON;

            if (role === Role.BORROWER)
              return document.scope === DocumentScopeType.BORROWER || document.scope === DocumentScopeType.COMMON;

            return false;
          })
          .map((document) => (
            <li key={document.name}>
              <DocumentCard
                title={document.file.name}
                date={document.publicationDate}
                fileUrl={document.file.url}
                fileName={document.file.name}
              />
            </li>
          ))}
      </ul>
    );
  };
  return (
    <>
      { isMobile ? <ProjectDropdown header="Документы">
        <div className="project-documents">
          { renderDocuments() }
        </div>
      </ProjectDropdown> : <>
        <div className="detailed-project__header">
          { navigation }
        </div>
        <div className="detailed-project__content">
          <div className={cn("project-documents", resultIf(mounted, "mounted"))}>
            { renderDocuments() }
          </div>
        </div>
      </>
      }
    </>
  );
};

export default ProjectDocuments;